// Utilitário combinado para campos que aceitam CPF ou CNPJ no mesmo input.
import { cleanCnpj, isValidCnpj, maskCnpj } from "./cnpj";
import { cleanCpf, isValidCpf, maskCpf } from "./cpf";

export const cleanDocumento = (value: string): string =>
    (value ?? "").toString().replace(/[^0-9A-Za-z]/g, "");

// Enquanto o usuário digita, decide entre máscara de CPF ou CNPJ com base na
// quantidade de caracteres já informados (CPF tem 11, CNPJ tem 14).
export const maskCpfCnpj = (value: string): string => {
    const clean = cleanDocumento(value);
    return clean.length > 11 ? maskCnpj(value) : maskCpf(value);
};

export const formatCpfOrCnpj = (value: string): string => {
    const clean = cleanDocumento(value);

    if (clean.length === 11) return maskCpf(clean);
    if (clean.length === 14) return maskCnpj(clean);

    return "Valor inválido para CPF ou CNPJ";
};

export const isValidCpfOrCnpj = (value: string): boolean => {
    const clean = cleanDocumento(value);

    if (clean.length === 11) return isValidCpf(clean);
    if (clean.length === 14) return isValidCnpj(clean);

    return false;
};

export { cleanCnpj, isValidCnpj, maskCnpj, cleanCpf, isValidCpf, maskCpf };
